import { render, staticRenderFns } from "./EmployeeMovementEdit.vue?vue&type=template&id=5d1b02f4&scoped=true&"
import script from "./EmployeeMovementEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b02f4",
  null
  
)

export default component.exports